'use strict';

var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["TrainScheduleResourceService", "ProjectService", "ReferenceAreaService", "$filter", "$q", "TrainScheduleFactory", "TimeZoneFactory", function TrainScheduleCrudFactory(TrainScheduleResourceService, ProjectService, ReferenceAreaService, $filter, $q, TrainScheduleFactory, TimeZoneFactory) {
    var factory = {
        getTimetable: getTimetable,
        saveTimetable: saveTimetable,
        saveTimetableEntry: saveTimetableEntry,
        getTrainSchedule: getTrainSchedule,
        saveTrainScheduleEntry: saveTrainScheduleEntry,
        updateTrainScheduleEntry: updateTrainScheduleEntry,
        removeTrainScheduleEntry: removeTrainScheduleEntry,
        getCurrentSchedule: getCurrentSchedule,
        getWaypoints: getWaypoints,
        saveWaypoints: saveWaypoints

    };

    return factory;

    /*
     FUNCTIONS
     */

    function getTimetable(projectId) {
        var deferred = $q.defer();
        var promise = TrainScheduleResourceService.timetable().query({projectId: projectId}).$promise;
        promise.then(function (data) {
            var timetable = [];
            data.forEach(function (entry) {
                timetable.push({
                    id: entry.id,
                    serviceId: entry.serviceId,
                    start: entry.start,
                    end: entry.end,
                    startStation: entry.startStation,
                    endStation: entry.endStation
                });
            });
            deferred.resolve(timetable);
        });
        return deferred.promise;

    }

    function saveTimetable(timetable, waypoints, projectId) {
        var saveableTimetable = [];
        timetable.forEach(function (entry) {
            var parsed = getSaveableService(entry, waypoints, projectId);
            saveableTimetable.push(parsed);
        });
        return TrainScheduleResourceService.timetable().save({projectId: projectId}, saveableTimetable).$promise;
    }

    function saveTimetableEntry(entry, projectId) {
        // entry.start = TrainScheduleFactory.parseTimeString(entry.start).getTime();
        // entry.end = TrainScheduleFactory.parseTimeString(entry.end).getTime();
        entry.projectId = projectId;
        return TrainScheduleResourceService.timetableEntry().save({projectId: projectId}, entry).$promise;
    }

    function getTrainSchedule(date) {
        return TrainScheduleResourceService.planning().query({
            projectId: ProjectService.getSelectedProjectId(),
            'date': TimeZoneFactory.format(date)
        }).$promise;

    }

    function saveTrainScheduleEntry(trainId, startStationId, endStationId, startTimeStr, endTimeStr, serviceId, timestamp) {
        var entry = {
            trainId: trainId,
            projectId: ProjectService.getSelectedProjectId(),
            timestamp: TimeZoneFactory.dateInCurrentTimeZone(timestamp).format(),

            timeTableEntry: {
                startStation: startStationId,
                endStation: endStationId,
                start: startTimeStr,
                end: endTimeStr,
                serviceId: serviceId,
                projectId: ProjectService.getSelectedProjectId()
            }

        };

        return TrainScheduleResourceService.scheduleEntries().save({
            'projectId': ProjectService.getSelectedProjectId()
        }, entry).$promise;
    }

    function updateTrainScheduleEntry(id, trainId, startStationId, endStationId, startDate, endDate, serviceId) {

        var entry = {
            id: id,
            trainId: trainId,
            projectId: ProjectService.getSelectedProjectId(),
            timestamp: startDate,
            timeTableEntry: {
                startStation: startStationId,
                endStation: endStationId,
                start: moment(startDate).format('HH:mm:ss'),
                end: moment(endDate).format('HH:mm:ss'),
                serviceId: serviceId
            }
        };

        return TrainScheduleResourceService.scheduleEntry().save({
            'projectId': ProjectService.getSelectedProjectId(),
            'id': id
        }, entry).$promise;
    }

    function removeTrainScheduleEntry(id, projectId) {
        return TrainScheduleResourceService.scheduleEntry().remove({id: id, projectId: projectId}).$promise;
    }


    function getCurrentSchedule(projectId) {
        return TrainScheduleResourceService.currentSchedule().query({projectId: projectId}).$promise;
    }

    function getWaypoints(projectId) {
        return ReferenceAreaService.waypoints().query({projectId: projectId}).$promise;
    }

    function saveWaypoints(waypointsFile, projectId) {
        var fileFormData = new FormData();
        fileFormData.append('file', waypointsFile);
        return ReferenceAreaService.uploadReferenceAreas(projectId, fileFormData).$promise;
    }

    /*
     PRIVATE FUNCTIONS
     */

    function getSaveableService(entry, waypoints, projectId) {
        return {
            id: entry.id,
            serviceId: entry.serviceId,
            projectId: projectId,
            // start: entry.start.getTime(),
            // end: entry.end.getTime(),
            start: entry.start,
            end: entry.end,
            startStation: getWaypointIdByAbbreviation(entry.startStation, waypoints),
            endStation: getWaypointIdByAbbreviation(entry.endStation, waypoints)
        }
    }

    function getWaypointIdByAbbreviation(abbr, waypoints) {
        return arrayUtil.getFirstInList(waypoints, "abbreviation", abbr.trim()).id;
    }
}];

